import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	messageText: {
		whiteSpace: "break-spaces"
	}
})

export default useStyles
